import { Row as AntDRow } from "antd"
import styled from "styled-components"

const Row = styled(AntDRow)`
  font-weight: bold;
`
export default Row
